import { EnumSchema } from '../metadata-schema';

export const Overgangmoment: EnumSchema = {
	"type": "string",
	"title": "Overgangmoment",
	"enum": [
		"Einde schooljaar",
		"Tussentijds"
	]
};
